import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { ControllerSymbolClientAction } from './controllerSymbolClient.action';
import { symbolClientControllerInitialState } from './controllerSymbolClient.constant';

export const controllerSymbolClientReducer = reducerWithInitialState(symbolClientControllerInitialState)
  .case(ControllerSymbolClientAction.setMode, (state, payload) => {
    return {
      ...state,
      mode: payload,
    };
  })
  .case(ControllerSymbolClientAction.destroy, () => ({
    ...symbolClientControllerInitialState,
  }));
